// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__DqiNJ","item":"PaymentsMobile_item__7vQrJ","label":"PaymentsMobile_label__3Qx2X","amount":"PaymentsMobile_amount__2klW6"};